import { IonPage, IonInput, IonLabel,IonSpinner } from "@ionic/react";
import { useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import service from "../Service/service";
import swal from 'sweetalert';
import { Infologo } from "../Entryfile/imagepath";
import { useForm } from "react-hook-form";

const Login: React.FC = () => {
    const history = useHistory();

    const { handleSubmit } = useForm({
        mode: "onTouched",
        reValidateMode: "onChange",
    });

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [data, setData] = useState([]);
    const [loading,setloading]=useState(false)
    const mailpat = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;

    const [eye, seteye] = useState(true);

    const onEyeClick = () => {
        seteye(!eye)
    }
    const onSubmit = () => {
        setloading(true); // Show loading indicator
        console.log("Submitting form with email:", email, "and password:", password);
    
        service.Login(email, password)
            .then((response) => {
                setTimeout(() => {
                    // Add a timeout to simulate a delay (you can adjust the duration)
                    if (response.data.status === "200") {
                        console.log(response);
                        setData(response.data);
                        localStorage.setItem("UserRole", response.data.role);
                        localStorage.setItem("empCode", response.data.employeeCode);
                        localStorage.setItem("EmpName", response.data.employeeName);
                        localStorage.setItem("SignupEmpId", response.data.signupEmployeeId);
                     localStorage.setItem("loginType",'local');
                        swal("", "Login Successfully", "success");
                        setEmail("");
                        setPassword("");
        
                        // Redirect to the appropriate dashboard based on the user's role
                        if (response.data.role === "Manager" || response.data.role === "MANAGER") {
                            history.push("/HRDashboard");
                        } else if (response.data.role === "TEAM_MEMBER") {
                            history.push("/EmployeeDashboard");
                        } else {
                            history.push("/HRDashboard");
                        }
                    } else {
                        swal("", response.data.message, "error");
                    }
                },);
            })
            .catch((error) => {
                console.error("Error logging in:", error);
            })
            .finally(() => {
               
                setTimeout(() => {
                    setloading(false); 
                }, 1500); 
            });
    };
    const SearchF = (value: any) => {
        if (value === "Enter") {
            if (email.length === 0) {
                swal("", "Enter Employee Code", "info");
            }
            // else if (mailpat.test(email) === false) {
            //     swal("", "Enter Valid Email Address", "info");
            // }
            else if (password.length == 0) {
                swal("", "Enter your Password", "info");
            }
            else {
                onSubmit()
            }
        }
    }

    return (
        <IonPage className="dark-mode">
            <form onSubmit={handleSubmit(onSubmit)} onKeyPress={e => SearchF(e.key)}>
                <div className="account-content">
                    <div className="container">
                        {/* Account Logo */}
                        <div className="account-logo">
                            <Link to="/">
                                <img src={Infologo} alt="INFOCAREER" />
                            </Link>
                        </div>
                        {/* /Account Logo */}
                        <div className="account-box">
                            <div className="account-wrapper">
                                <h3 className="account-title">Login</h3>
                                <p className="account-subtitle">Access to our dashboard</p>
                                <div>
                                    <div className="form-group">
                                        <IonLabel>Employee Code</IonLabel>
                                        <IonInput className="form-control" value={email} onIonChange={(e: any) => setEmail(e.detail.value)} />
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col">
                                                <IonLabel>Password</IonLabel>
                                            </div>
                                            <div className="pass-group">
                                                <IonInput type={eye ? "password" : "text"} value={password} className="form-control" onIonChange={(e: any) => setPassword(e.detail.value)} />
                                                <span onClick={onEyeClick} className={`fa toggle-password" ${eye ? "fa-eye-slash" : "fa-eye"}`} />
                                            </div>
                                            {/* <div className="col-auto">
                                            <Link className="text-muted" to="/forgotpassword">
                                                Forgot password?
                                            </Link>
                                        </div> */}
                                        </div>
                                    </div>
                                    {loading && (
            <div
              style={{
                position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
              }}
            >
              <div >
                <IonSpinner style={{
                  width: "40px",
                  height: "40px",
                  color: "#ff8a53"

                }} name="lines" />
              </div>
            </div>
          )}
                                    <div className="form-group text-center">
                                        <button
                                            className="btn btn-primary account-btn"
                                            type="submit"
                                            // disabled={email.length === 0 || password.length === 0}
                                        // onClick={() => onSubmit()}
                                        >
                                            Login
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </IonPage>
    );
}

export default Login